import React from 'react';

/* 25th–75th percentile test-score bands on a FIXED axis (SAT 200–800,
   ACT 1–36), so two schools' rails are directly comparable rather than each
   filling its own width. Ported from `RangeRail` in MatchDetailSheet.swift.

   A rail shows when either endpoint is present; a missing endpoint reads "?"
   in the header and collapses that side of the band. */

export default function RangeRail({ rails }) {
  const shown = rails.filter((r) => r.range && (r.range.low != null || r.range.high != null));
  if (shown.length === 0) return null;

  return (
    <div className="sd-chart">
      {shown.map((cfg) => {
        const { low, high } = cfg.range;
        const span = cfg.axisMax - cfg.axisMin;
        const lo = low ?? cfg.axisMin;
        const hi = high ?? cfg.axisMin;
        const leftPct = span > 0 ? ((lo - cfg.axisMin) / span) * 100 : 0;
        const widthPct = span > 0 ? ((hi - lo) / span) * 100 : 0;
        const text = `${low ?? '?'}–${high ?? '?'}`;
        return (
          <div className="sd-rail" key={cfg.label}>
            <div className="sd-rail__head">
              <span className="sd-rail__label">{cfg.label}</span>
              <span className="sd-rail__value">{text}</span>
            </div>
            <div
              className="sd-track"
              role="img"
              aria-label={`${cfg.label}, middle 50 percent of admitted students scored ${text}, on a scale of ${cfg.axisMin} to ${cfg.axisMax}`}
            >
              {/* 4px floor so a narrow band (or a one-ended range) stays visible. */}
              <div
                className="sd-track__fill"
                style={{ left: `${leftPct.toFixed(2)}%`, width: `max(4px, ${widthPct.toFixed(2)}%)` }}
              />
            </div>
            <div className="sd-rail__axis" aria-hidden="true">
              <span>{cfg.axisMin}</span>
              <span>{cfg.axisMax}</span>
            </div>
          </div>
        );
      })}
    </div>
  );
}
